<template>
  <div class="tip-box">
    <!-- <div class="icon-box">
      <van-icon class="tip-icon" :name="iconName" />
    </div> -->

    <p class="content">提示：{{ content }}</p>
  </div>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'warning'
    },
    content: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="less" scoped>
.tip-box {
  padding: 12px;
  display: flex;
  border-radius: 4px;
  background: #ebf8ff;
  // .icon-box {
  //   min-width: 12px;
  //   .tip-icon {
  //     font-size: 12px;
  //     line-height: 20px;
  //     color: #4891fc;
  //   }
  // }
  .content {
    // margin-left: 4px;
    // font-size: 14px;
    // line-height: 20px;
    // // font: 400 13px/20px PingFangSC-Regular, PingFang SC;
    // color: #1e8dff;
    font-size: 14px;
    font-weight: 400;
    color: #1e8dff;
    line-height: 21px;
  }
}
</style>
